import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    deleteBtn: {
        alignSelf: 'center'
    }
});

export default styles;